/**
 * This class stores the database errors.
 */
module.exports = class JsonException {
	constructor(exception, message, code, file, line, trace, statucCode) {
		this.name = 'JsonException';
		this.exception = exception;
		this.message = message;
		this.code = code;
		this.file = file;
		this.line = line;
		this.trace = trace;
		this.statusCode = statucCode;
	}
}
